module.exports = __webpack_public_path__ + "static/media/vendors_header_bg.d9cd704b.jpeg";